// React Thirty Party Library
import { Form, message } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Components Library
import { Options } from "../../../../../../components";

// Handler Library

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

import DrawerFormEmployee from "../DrawerFormEmployee";

const { reduxStoreWrapper } = REDUX_UTIL

const { bankList } = Options

const DrawerAddEmployee = (props) => {
  const { isOpen, setIsOpen } = props;

  const dispatch = useDispatch();

  const [messageApi, contextHolder] = message.useMessage();
  
  const [form] = Form.useForm();

  const user = useSelector(reduxStoreWrapper("user"));

  const createEmployee = () => {
    form
      .validateFields()
      .then((values) => {

        messageApi.open({
          type: "loading",
          content: "Create Employee...",
          duration: 0,
        });

        const selectedBank = bankList.find((bank) => bank.value.name === values.bank_name);
        const bank_code = selectedBank ? selectedBank.value.bank_code : '';

        const formattedIc = values.ic.replace(/-/g, '');
        const formattedBankHolderIc = values.bank_holderIc.replace(/-/g, '');

        const employeeData = {
          ...values,
          ...(user.uroleid === 'EMR' && { coid: user.coid }),
          contact : `+60${values.contact}`,
          bank_code: bank_code,
          ic: formattedIc,
          bank_holderIc: formattedBankHolderIc,
          createdBy: user.memid,
          createdAt: new Date().toISOString(),
        }

        dispatch(
          REDUX_ACTION.v1_employee.create_employee(employeeData, user.uroleid, () => {
            messageApi.destroy();
          })
        );
        form.resetFields();

      })
      .catch((error) => {
        message.error("fill the form");
      });
  };

  return (
    <>
    {contextHolder}
    <DrawerFormEmployee
        form={form}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        type="add"
        handleSave={createEmployee}
    />
    </>
  );
};

export default DrawerAddEmployee;
